import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@styles/common.css";

import { AuthContextProvider } from "@contexts/AuthContext";

/**
 * Patch ResizeObserver to prevent:
 * "ResizeObserver loop completed with undelivered notifications"
 *
 * This delays resize callbacks to the next animation frame,
 * preventing layout-triggered resize loops (common with PDF viewers).
 */
if (typeof window !== "undefined" && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class PatchedResizeObserver extends (
    OriginalResizeObserver
  ) {
    constructor(callback) {
      let rafId = null;

      super((entries, observer) => {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
        }

        rafId = requestAnimationFrame(() => {
          rafId = null;
          callback(entries, observer);
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </React.StrictMode>,
);
